import { render, staticRenderFns } from "./Entrymessage.vue?vue&type=template&id=27b61130&scoped=true&"
import script from "./Entrymessage.vue?vue&type=script&lang=js&"
export * from "./Entrymessage.vue?vue&type=script&lang=js&"
import style0 from "./Entrymessage.vue?vue&type=style&index=0&id=27b61130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b61130",
  null
  
)

export default component.exports